import { useEffect, useState } from 'react';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="flex items-center justify-between h-20">
            <a className="flex items-center gap-3" href="/">
              <img 
                alt="Hearts of Love Logo" 
                className="h-12 w-12 object-contain" 
                src="https://static.readdy.ai/image/d681489af65230a5411b61d45fe6420c/ccdb2c3b737983542d07d1620e150fe2.png"
              />
              <div className="flex flex-col">
                <span className={`font-serif font-bold text-xl transition-colors ${isScrolled ? 'text-pink-600' : 'text-white'}`}>Hearts of Love</span>
                <span className={`text-xs transition-colors ${isScrolled ? 'text-gray-600' : 'text-white/90'}`}>Hạt cườm nhỏ - Ước mơ lớn</span>
              </div>
            </a>
            <div className="hidden md:flex items-center gap-8">
              <a className={`font-medium transition-colors whitespace-nowrap ${isScrolled ? 'text-pink-600' : 'text-white'}`} href="/">Trang chủ</a>
              <a className={`font-medium transition-colors whitespace-nowrap ${isScrolled ? 'text-gray-700 hover:text-pink-600' : 'text-white/90 hover:text-white'}`} href="/about">Câu chuyện</a>
              <a className={`font-medium transition-colors whitespace-nowrap ${isScrolled ? 'text-gray-700 hover:text-pink-600' : 'text-white/90 hover:text-white'}`} href="/products">Sản phẩm</a>
            </div>
            <a href="https://zalo.me/0976753302" target="_blank" rel="noopener noreferrer" className="hidden md:block px-6 py-2.5 rounded-full font-medium transition-all whitespace-nowrap cursor-pointer bg-pink-500 text-white hover:bg-pink-600">
              Liên hệ ngay
            </a>
            <button className="md:hidden">
              <i className={`ri-menu-line text-2xl ${isScrolled ? 'text-pink-600' : 'text-white'}`}></i>
            </button>
          </div>
        </div>
      </nav>

      <main>
        {/* Hero Section */}
        <section className="relative h-screen flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0">
            <img 
              alt="Heart of Love - Hạt cườm thủ công" 
              className="w-full h-full object-cover object-top" 
              src="https://drive.google.com/thumbnail?id=1_MH95ninEWelzPSWPO3FfdXZTJaUUGLM&sz=w2000"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
          </div>
          <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 w-full">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <h1 className="mb-8">
                  <span className="block font-serif text-7xl lg:text-8xl text-white font-light mb-2">Hạt cườm nhỏ</span>
                  <span className="block font-serif text-7xl lg:text-8xl text-white font-bold">Ước mơ lớn</span>
                </h1>
                <a href="#about" className="inline-flex items-center gap-2 px-8 py-4 bg-pink-500 text-white rounded-full font-medium hover:bg-pink-600 transition-all cursor-pointer whitespace-nowrap">
                  Khám phá câu chuyện
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
              <div className="lg:text-right">
                <p className="text-white text-lg leading-relaxed max-w-xl lg:ml-auto">
                  Mỗi sản phẩm là một hành trình kiên trì, là niềm tin vào cuộc sống, và là ước mơ được hòa nhập của những người không nhìn thấy ánh sáng
                </p>
              </div>
            </div>
          </div>
          <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
            <i className="ri-arrow-down-line text-white text-3xl"></i>
          </div>
        </section>

        {/* Products Section */}
        <section id="products" className="py-24 bg-pink-50" data-product-shop="true">
          <div className="max-w-7xl mx-auto px-6 lg:px-12">
            <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center mb-16 gap-6">
              <div>
                <h2 className="font-sans font-bold text-5xl lg:text-6xl text-pink-700 leading-tight">
                  Sản phẩm thủ công<br />Từ trái tim yêu thương
                </h2>
              </div>
              <div className="lg:max-w-md">
                <p className="text-gray-600 text-base leading-relaxed">
                  Mỗi món đồ được làm hoàn toàn bằng tay, mang theo câu chuyện và tâm huyết riêng
                </p>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              <div>
                <div className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-shadow h-full group cursor-pointer">
                  <div className="relative h-80 w-full overflow-hidden">
                    <img 
                      alt="Móc khóa/ charm Trái tim" 
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" 
                      src="https://drive.google.com/thumbnail?id=1xkBgrf4gL8k5hgPeQz1s31HroLX3cKaH&sz=w2000"
                    />
                    <div className="absolute top-4 right-4 bg-pink-300 text-pink-700 px-4 py-2 rounded-full text-sm font-medium">
                      Bán chạy nhất
                    </div>
                  </div>
                  <div className="p-6">
                    <h3 className="font-serif text-2xl text-black mb-2">Móc khóa/ charm Trái tim</h3>
                    <p className="font-sans font-bold text-xl text-pink-600 mb-3">Từ 20.000đ</p>
                    <p className="text-gray-600 text-sm leading-relaxed mb-4">16 màu sắc • Bao gồm túi organza &amp; thiệp ý nghĩa</p>
                    <a className="inline-flex items-center gap-2 text-pink-600 font-medium hover:text-pink-700 transition-colors cursor-pointer whitespace-nowrap" href="/products">
                      Xem chi tiết
                      <i className="ri-arrow-right-line"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div>
                <div className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-shadow h-full group cursor-pointer">
                  <div className="relative h-80 w-full overflow-hidden">
                    <img 
                      alt="Blue Hello Kitty" 
                      className="w-full h-full object-contain object-center group-hover:scale-105 transition-transform duration-500" 
                      src="https://drive.google.com/thumbnail?id=1cwzGB7kyhMuXiB0PvpfNR7zTZNoHQgOx&sz=w1000"
                    />
                  </div>
                  <div className="p-6">
                    <h3 className="font-serif text-2xl text-black mb-2">Blue Hello Kitty</h3>
                    <p className="font-sans font-bold text-xl text-pink-600 mb-3">35.000đ</p>
                    <p className="text-gray-600 text-sm leading-relaxed mb-4">Bao gồm túi organza &amp; thiệp ý nghĩa</p>
                    <a className="inline-flex items-center gap-2 text-pink-600 font-medium hover:text-pink-700 transition-colors cursor-pointer whitespace-nowrap" href="/products">
                      Xem chi tiết
                      <i className="ri-arrow-right-line"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div>
                <div className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-shadow h-full group cursor-pointer">
                  <div className="relative h-80 w-full overflow-hidden">
                    <img 
                      alt="Pink Hello Kitty" 
                      className="w-full h-full object-contain object-center group-hover:scale-105 transition-transform duration-500" 
                      src="https://drive.google.com/thumbnail?id=14k5_Mcs29mQuuZP1gJIHErjjHIPdpR1a&sz=w1000"
                    />
                  </div>
                  <div className="p-6">
                    <h3 className="font-serif text-2xl text-black mb-2">Pink Hello Kitty</h3>
                    <p className="font-sans font-bold text-xl text-pink-600 mb-3">35.000đ</p>
                    <p className="text-gray-600 text-sm leading-relaxed mb-4">Bao gồm túi organza &amp; thiệp ý nghĩa</p>
                    <a className="inline-flex items-center gap-2 text-pink-600 font-medium hover:text-pink-700 transition-colors cursor-pointer whitespace-nowrap" href="/products">
                      Xem chi tiết
                      <i className="ri-arrow-right-line"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div>
                <div className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-shadow h-full group cursor-pointer">
                  <div className="relative h-80 w-full overflow-hidden">
                    <img 
                      alt="Happy Monkey" 
                      className="w-full h-full object-contain object-center group-hover:scale-105 transition-transform duration-500" 
                      src="https://static.readdy.ai/image/5a848622a3e6dbb60998be004dc90877/a5a6fc4bd18d0c12995a2549af50791f.png"
                    />
                  </div>
                  <div className="p-6">
                    <h3 className="font-serif text-2xl text-black mb-2">Happy Monkey</h3>
                    <p className="font-sans font-bold text-xl text-pink-600 mb-3">35.000đ</p>
                    <p className="text-gray-600 text-sm leading-relaxed mb-4">Bao gồm túi organza &amp; thiệp ý nghĩa</p>
                    <a className="inline-flex items-center gap-2 text-pink-600 font-medium hover:text-pink-700 transition-colors cursor-pointer whitespace-nowrap" href="/products">
                      Xem chi tiết
                      <i className="ri-arrow-right-line"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div>
                <div className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-shadow h-full group cursor-pointer">
                  <div className="relative h-80 w-full overflow-hidden">
                    <img 
                      alt="Merry Horse" 
                      className="w-full h-full object-contain object-center group-hover:scale-105 transition-transform duration-500" 
                      src="https://drive.google.com/thumbnail?id=1zJwRoSgPZ4PpK_yERW5A_RZtrdg0llur&sz=w1000"
                    />
                  </div>
                  <div className="p-6">
                    <h3 className="font-serif text-2xl text-black mb-2">Merry Horse</h3>
                    <p className="font-sans font-bold text-xl text-pink-600 mb-3">35.000đ</p>
                    <p className="text-gray-600 text-sm leading-relaxed mb-4">Bao gồm túi organza &amp; thiệp ý nghĩa</p>
                    <a className="inline-flex items-center gap-2 text-pink-600 font-medium hover:text-pink-700 transition-colors cursor-pointer whitespace-nowrap" href="/products">
                      Xem chi tiết
                      <i className="ri-arrow-right-line"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div>
                <div className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-shadow h-full group cursor-pointer">
                  <div className="relative h-80 w-full overflow-hidden">
                    <img 
                      alt="Happy Pig" 
                      className="w-full h-full object-contain object-center group-hover:scale-105 transition-transform duration-500" 
                      src="https://drive.google.com/thumbnail?id=1e8OhPwe62RvP0nMVIsyMwYxTsZlJXE4w&sz=w1000"
                    />
                  </div>
                  <div className="p-6">
                    <h3 className="font-serif text-2xl text-black mb-2">Happy Pig</h3>
                    <p className="font-sans font-bold text-xl text-pink-600 mb-3">35.000đ</p>
                    <p className="text-gray-600 text-sm leading-relaxed mb-4">Bao gồm túi organza &amp; thiệp ý nghĩa</p>
                    <a className="inline-flex items-center gap-2 text-pink-600 font-medium hover:text-pink-700 transition-colors cursor-pointer whitespace-nowrap" href="/products">
                      Xem chi tiết
                      <i className="ri-arrow-right-line"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* About Section */}
        <section id="about" className="py-32 bg-pink-100">
          <div className="max-w-7xl mx-auto px-6 lg:px-12">
            <div className="mb-20">
              <div className="inline-block bg-pink-300 text-pink-700 px-5 py-2 rounded-full text-sm font-medium mb-8">
                Câu chuyện của chúng tôi
              </div>
              <div className="max-w-4xl">
                <p className="font-sans text-2xl lg:text-3xl text-pink-700 leading-relaxed mb-6">
                  <strong className="font-semibold">"Hạt cườm nhỏ"</strong> là những vật liệu bé xíu, tưởng chừng giản đơn, nhưng lại chứa đựng nỗ lực, kiên nhẫn, niềm tin và hy vọng của những người không nhìn thấy ánh sáng.
                </p>
                <p className="font-sans text-2xl lg:text-3xl text-pink-700 leading-relaxed mb-6">
                  <strong className="font-semibold">"Ước mơ lớn"</strong> là ước mơ được sống độc lập, có thu nhập, được học tập, làm việc, hòa nhập và được công nhận như bao người khác.
                </p>
                <p className="font-sans text-2xl lg:text-3xl text-pink-700 leading-relaxed">
                  Mỗi chiếc móc khóa/ charm hạt cườm không chỉ là một sản phẩm thủ công, mà là một giấc mơ được đan kết bằng nghị lực và bền bỉ. Khi mua sản phẩm Hearts of Love, bạn không chỉ mua một món quà nhỏ, mà đang chung tay nuôi dưỡng những ước mơ lớn.
                </p>
              </div>
            </div>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-20">
              <div className="text-center lg:text-left">
                <div className="font-sans font-bold text-6xl lg:text-7xl text-pink-600 mb-3">10+</div>
                <div className="font-sans text-base text-gray-600 font-light">Người kết hạt cườm khiếm thị</div>
              </div>
              <div className="text-center lg:text-left">
                <div className="font-sans font-bold text-6xl lg:text-7xl text-pink-600 mb-3">2.000+</div>
                <div className="font-sans text-base text-gray-600 font-light">Sản phẩm đã được tạo ra</div>
              </div>
              <div className="text-center lg:text-left">
                <div className="font-sans font-bold text-6xl lg:text-7xl text-pink-600 mb-3">100%</div>
                <div className="font-sans text-base text-gray-600 font-light">Làm thủ công hoàn toàn</div>
              </div>
              <div className="text-center lg:text-left">
                <div className="font-sans font-bold text-6xl lg:text-7xl text-pink-600 mb-3">1-3 ngày</div>
                <div className="font-sans text-base text-gray-600 font-light">Để hoàn thành một sản phẩm</div>
              </div>
            </div>
          </div>
        </section>

        {/* Why Choose Section */}
        <section className="py-24 bg-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-12">
            <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center mb-16 gap-6">
              <div>
                <h2 className="font-sans font-bold text-5xl lg:text-6xl text-black leading-tight">
                  Tại sao chọn<br />Hearts of Love?
                </h2>
              </div>
              <div className="lg:max-w-md">
                <p className="text-gray-600 text-base leading-relaxed">
                  Những giá trị cốt lõi làm nên sự khác biệt của chúng tôi
                </p>
              </div>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
              <div className="lg:col-span-5">
                <div className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-shadow h-full">
                  <div className="relative h-80 w-full overflow-hidden">
                    <img 
                      alt="100% thủ công" 
                      className="w-full h-full object-cover object-top" 
                      src="https://drive.google.com/thumbnail?id=1rl2NpZyCz6wjXWonTZcq4DzYqZQaJord&sz=w2000"
                    />
                  </div>
                  <div className="p-8">
                    <div className="w-12 h-12 flex items-center justify-center bg-pink-100 rounded-xl mb-4">
                      <i className="ri-hand-heart-line text-2xl text-pink-600"></i>
                    </div>
                    <h3 className="font-sans font-bold text-2xl text-black mb-3">100% thủ công</h3>
                    <p className="text-gray-600 text-base leading-relaxed">
                      Mỗi sản phẩm được làm hoàn toàn bằng tay, từng hạt cườm được xỏ tỉ mỉ với sự kiên nhẫn và tâm huyết.
                    </p>
                  </div>
                </div>
              </div>
              <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div>
                  <div className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-shadow h-full flex flex-col">
                    <div className="p-8 flex-1">
                      <div className="w-12 h-12 flex items-center justify-center bg-pink-100 rounded-xl mb-4">
                        <i className="ri-shield-check-line text-2xl text-pink-600"></i>
                      </div>
                      <h3 className="font-sans font-bold text-xl text-black mb-3">Minh bạch nguồn gốc</h3>
                      <p className="text-gray-600 text-sm leading-relaxed">
                        Tất cả sản phẩm đều được làm tại Mái Ấm Khiếm Thị Nhật Hồng, đảm bảo nguồn gốc rõ ràng và chất lượng.
                      </p>
                    </div>
                    <div className="relative h-64 w-full overflow-hidden">
                      <img 
                        alt="Minh bạch nguồn gốc" 
                        className="w-full h-full object-cover object-top" 
                        src="https://drive.google.com/thumbnail?id=1erZuv_TrvBF8pqyknCibNt8y3BRZha0v&sz=w2000"
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <div className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-shadow h-full flex flex-col">
                    <div className="p-8 flex-1">
                      <div className="w-12 h-12 flex items-center justify-center bg-pink-100 rounded-xl mb-4">
                        <i className="ri-heart-3-line text-2xl text-pink-600"></i>
                      </div>
                      <h3 className="font-sans font-bold text-xl text-black mb-3">Tác động xã hội</h3>
                      <p className="text-gray-600 text-sm leading-relaxed">
                        Mỗi sản phẩm bán ra giúp tăng thu nhập cho người khiếm thị, tạo cơ hội hòa nhập và lan tỏa yêu thương.
                      </p>
                    </div>
                    <div className="relative h-64 w-full overflow-hidden">
                      <img 
                        alt="Tác động xã hội" 
                        className="w-full h-full object-cover object-top" 
                        src="https://drive.google.com/thumbnail?id=1Zrd70BcUHBZwXowuU6IcOUBCj1yNVw2a&sz=w2000"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        <section className="py-24 bg-gray-50">
          <div className="max-w-7xl mx-auto px-6 lg:px-12">
            <div className="mb-16">
              <div className="inline-block bg-pink-200 text-pink-700 px-5 py-2 rounded-full text-sm font-medium mb-6">
                Giá trị cộng đồng
              </div>
              <h2 className="font-sans font-bold text-5xl lg:text-6xl text-black leading-tight">
                Những câu chuyện<br />Lan tỏa yêu thương
              </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              <div>
                <div className="bg-white rounded-2xl p-7 shadow-sm hover:shadow-lg transition-shadow h-full">
                  <div className="flex items-center gap-4 mb-5">
                    <div className="w-14 h-14 rounded-full bg-gradient-to-br from-teal-300 to-teal-500 flex items-center justify-center text-white font-bold text-xl">N</div>
                    <div>
                      <h4 className="font-semibold text-lg text-black">Cô dâu Ngọc Minh</h4>
                      <p className="text-sm text-gray-500 flex items-center gap-1">
                        <i className="ri-map-pin-line text-xs"></i>TP.HCM
                      </p>
                    </div>
                  </div>
                  <p className="text-gray-700 text-sm leading-relaxed">
                    "Tụi mình rất vui khi chọn những trái tim hạt cườm do các anh chị khiếm thị làm ra để gửi tặng khách mời. Sản phẩm không chỉ xinh xắn, dễ thương mà còn mang ý nghĩa nhân văn sâu sắc, khiến ngày cưới thêm trọn vẹn yêu thương."
                  </p>
                </div>
              </div>
              <div className="lg:mt-12">
                <div className="bg-white rounded-2xl p-7 shadow-sm hover:shadow-lg transition-shadow h-full">
                  <div className="flex items-center gap-4 mb-5">
                    <div className="w-14 h-14 rounded-full bg-gradient-to-br from-blue-300 to-blue-500 flex items-center justify-center text-white font-bold text-xl">H</div>
                    <div>
                      <h4 className="font-semibold text-lg text-black">H. Bui</h4>
                      <p className="text-sm text-gray-500 flex items-center gap-1">
                        <i className="ri-map-pin-line text-xs"></i>Đức
                      </p>
                    </div>
                  </div>
                  <p className="text-gray-700 text-sm leading-relaxed">
                    "Dịp sinh nhật mẹ tôi (sinh năm Đinh Sửu), tôi đã đặt làm một chú trâu bằng hạt cườm. Sản phẩm khi hoàn thiện có một mắt màu đen và một mắt màu trắng. Các bạn khiếm thị đã định tháo ra làm lại nhưng tôi đồng ý mua nguyên trạng, vui vẻ nhận sản phẩm — không chỉ vì nó độc nhất vô nhị, mấy ai có một chú trâu với hai mắt khác màu như vậy 😊— mà còn vì bản thân tôi cũng từng làm đồ thủ công bằng hạt cườm nên rất hiểu rằng việc xỏ từng hạt cườm nhỏ xíu, canh đúng những lỗ li ti ấy đã khó, mà cả quá trình còn vô cùng tỉ mỉ và tốn công."
                  </p>
                </div>
              </div>
              <div>
                <div className="bg-white rounded-2xl p-7 shadow-sm hover:shadow-lg transition-shadow h-full">
                  <div className="flex items-center gap-4 mb-5">
                    <div className="w-14 h-14 rounded-full bg-gradient-to-br from-purple-300 to-purple-500 flex items-center justify-center text-white font-bold text-xl">L</div>
                    <div>
                      <h4 className="font-semibold text-lg text-black">Lê Nhung</h4>
                      <p className="text-sm text-gray-500 flex items-center gap-1">
                        <i className="ri-map-pin-line text-xs"></i>Doanh nghiệp • Đức
                      </p>
                    </div>
                  </div>
                  <p className="text-gray-700 text-sm leading-relaxed">
                    "Món quà nghị lực và kiên định. Tôi đang sinh sống và làm việc tại Đức, muốn mua món quà nhỏ để tri ân khách hàng. Tôi đã chọn mua những sản phẩm của các em khiếm thị để tặng quà cho khách hàng. Nhìn những sản phẩm do các em khiếm thị làm ra mà tôi và những khách hàng rất cảm động vì những nghị lực kiên trì phi thường."
                  </p>
                </div>
              </div>
              <div>
                <div className="bg-white rounded-2xl p-7 shadow-sm hover:shadow-lg transition-shadow h-full">
                  <div className="flex items-center gap-4 mb-5">
                    <div className="w-14 h-14 rounded-full bg-gradient-to-br from-green-300 to-green-500 flex items-center justify-center text-white font-bold text-xl">H</div>
                    <div>
                      <h4 className="font-semibold text-lg text-black">Hong Nguyen</h4>
                      <p className="text-sm text-gray-500 flex items-center gap-1">
                        <i className="ri-map-pin-line text-xs"></i>PEI • Canada
                      </p>
                    </div>
                  </div>
                  <p className="text-gray-700 text-sm leading-relaxed">
                    "Tôi đặt làm 100 trái tim hạt cườm dễ thương, màu sắc tươi đẹp long lanh. Hạt cườm nhỏ, lan tỏa yêu thương, tình yêu dành cho những hoàn cảnh muốn vượt lên số phận. Khách hàng của tôi rất thích nhận món quà đầy ý nghĩa như vậy. Đám cưới sắp tới của con cháu chúng tôi cũng sẽ xử dụng món quà trái tim hạt cườm tặng khách mời dự lễ cưới, tạo thêm phước lành cho ngày vui của đôi trẻ."
                  </p>
                </div>
              </div>
              <div className="lg:mt-12">
                <div className="bg-white rounded-2xl p-7 shadow-sm hover:shadow-lg transition-shadow h-full">
                  <div className="flex items-center gap-4 mb-5">
                    <div className="w-14 h-14 rounded-full bg-gradient-to-br from-yellow-300 to-yellow-500 flex items-center justify-center text-white font-bold text-xl">T</div>
                    <div>
                      <h4 className="font-semibold text-lg text-black">Tuyết Sương</h4>
                      <p className="text-sm text-gray-500 flex items-center gap-1">
                        <i className="ri-map-pin-line text-xs"></i>Pháp
                      </p>
                    </div>
                  </div>
                  <p className="text-gray-700 text-sm leading-relaxed">
                    "Trái tim và những con thú nhỏ thật đẹp. Tôi vô cùng khâm phục các bạn đã tạo nên những món quà tí hon bằng hạt cườm, nhất là khi các bạn là người khiếm thị. Tôi cứ tự hỏi làm sao các bạn có thể khéo léo đến vậy, bởi ngay cả khi nhìn rõ ràng thì việc này cũng thật khó. Hoan hô các bạn! Chúc các bạn luôn thành công."
                  </p>
                </div>
              </div>
              <div>
                <div className="bg-white rounded-2xl p-7 shadow-sm hover:shadow-lg transition-shadow h-full">
                  <div className="flex items-center gap-4 mb-5">
                    <div className="w-14 h-14 rounded-full bg-gradient-to-br from-red-300 to-red-500 flex items-center justify-center text-white font-bold text-xl">H</div>
                    <div>
                      <h4 className="font-semibold text-lg text-black">H. S. Khoa</h4>
                      <p className="text-sm text-gray-500 flex items-center gap-1">
                        <i className="ri-map-pin-line text-xs"></i>Pháp
                      </p>
                    </div>
                  </div>
                  <p className="text-gray-700 text-sm leading-relaxed">
                    "Những sản phẩm làm từ hạt cườm của các em khiếm thị tại Mái Ấm Khiếm Thị Nhật Hồng thật sự khiến người dùng xúc động và trân trọng. Từng chi tiết nhỏ đều thể hiện sự kiên nhẫn, tỉ mỉ và đôi bàn tay vô cùng khéo léo, gửi gắm trong đó là rất nhiều công sức và tâm huyết. Đặc biệt, mức giá rất phải chăng càng làm cho những sản phẩm này trở nên đáng quý hơn."
                  </p>
                </div>
              </div>
              <div>
                <div className="bg-white rounded-2xl p-7 shadow-sm hover:shadow-lg transition-shadow h-full">
                  <div className="flex items-center gap-4 mb-5">
                    <div className="w-14 h-14 rounded-full bg-gradient-to-br from-pink-300 to-pink-500 flex items-center justify-center text-white font-bold text-xl">K</div>
                    <div>
                      <h4 className="font-semibold text-lg text-black">Kandle Dart</h4>
                      <p className="text-sm text-gray-500 flex items-center gap-1">
                        <i className="ri-map-pin-line text-xs"></i>IL, Mỹ
                      </p>
                    </div>
                  </div>
                  <p className="text-gray-700 text-sm leading-relaxed">
                    "The little hearts and mini animals come in a wide range of colors and are absolutely adorable. In addition to giving them as gifts, I've also used them as decorative charms attached to my iPhone, Apple AirPods case, and various craft projects. These beautiful little pieces don't just bring a smile to the receiver—they also bring an even bigger smile to the maker, knowing their work is appreciated and serves a meaningful purpose."
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section id="contact" className="grid grid-cols-1 lg:grid-cols-2">
          <div className="relative bg-pink-200 flex items-end p-12 lg:p-16 min-h-[600px]">
            <div className="absolute inset-0">
              <img 
                alt="Quà tặng ý nghĩa cho sự kiện" 
                className="w-full h-full object-cover object-top opacity-90" 
                src="https://drive.google.com/thumbnail?id=1YaY8HrWj2laIkBAg-kB4n5W0K_W6Muh0&sz=w2000"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
            </div>
            <div className="relative z-10 text-white">
              <p className="text-sm font-light mb-4 tracking-wide">Dành cho doanh nghiệp</p>
              <h3 className="font-sans font-bold leading-tight">
                <span className="block text-5xl mb-2">Quà tặng</span>
                <span className="block text-6xl mb-2">Ý nghĩa</span>
                <span className="block text-7xl">Cho sự kiện</span>
              </h3>
            </div>
          </div>
          <div className="bg-white flex items-center justify-center p-12 lg:p-16 min-h-[600px]">
            <div className="max-w-lg w-full">
              <h2 className="font-sans font-bold text-4xl lg:text-5xl text-black text-center mb-8 leading-tight">
                Đặt hàng số lượng lớn<br />Giá ưu đãi đặc biệt
              </h2>
              <p className="text-gray-600 text-base leading-relaxed text-center mb-10 max-w-md mx-auto">
                Phù hợp cho quà cưới, quà tri ân khách hàng, quà sự kiện doanh nghiệp. Từ 100 bộ trở lên, bạn sẽ nhận được mức giá tốt nhất và hỗ trợ tư vấn thiết kế riêng
              </p>
              <div className="grid grid-cols-3 gap-4 mb-10">
                <div className="bg-pink-100 rounded-xl p-4 text-center">
                  <p className="text-xs text-gray-600 mb-1">100-199 bộ</p>
                  <p className="font-bold text-lg text-pink-600">22.000đ</p>
                </div>
                <div className="bg-pink-100 rounded-xl p-4 text-center">
                  <p className="text-xs text-gray-600 mb-1">200-499 bộ</p>
                  <p className="font-bold text-lg text-pink-600">20.000đ</p>
                </div>
                <div className="bg-pink-100 rounded-xl p-4 text-center">
                  <p className="text-xs text-gray-600 mb-1">500+ bộ</p>
                  <p className="font-bold text-lg text-pink-600">Liên hệ</p>
                </div>
              </div>
              <a href="https://zalo.me/0976753302" target="_blank" rel="noopener noreferrer" className="w-full flex items-center justify-center gap-2 px-8 py-4 bg-pink-500 text-white rounded-full font-medium hover:bg-pink-600 transition-all cursor-pointer whitespace-nowrap">
                Liên hệ tư vấn ngay
                <i className="ri-arrow-right-line"></i>
              </a>
              <div className="mt-8 text-center">
                <p className="text-sm text-gray-500 mb-2">Hoặc liên hệ trực tiếp qua:</p>
                <div className="flex items-center justify-center gap-4">
                  <a href="tel:0785976111" className="flex items-center gap-2 text-pink-600 hover:text-pink-700 transition-colors cursor-pointer whitespace-nowrap">
                    <i className="ri-phone-line"></i>
                    <span className="text-sm">0785976111</span>
                  </a>
                  <span className="text-gray-300">|</span>
                  <a href="tel:0976753302" className="flex items-center gap-2 text-pink-600 hover:text-pink-700 transition-colors cursor-pointer whitespace-nowrap">
                    <i className="ri-message-3-line"></i>
                    <span className="text-sm">0976753302</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-pink-500 text-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
            <div className="md:col-span-5">
              <h2 className="font-serif font-bold text-5xl mb-2">Hearts of Love</h2>
              <p className="text-pink-100/80 text-base mb-6">Hạt cườm nhỏ - Ước mơ lớn</p>
              <p className="text-pink-100/70 text-sm leading-relaxed mb-8 w-11/12">
                Mỗi sản phẩm thủ công từ Hearts of Love là một câu chuyện về nghị lực, kiên trì và ước mơ hòa nhập của những người khiếm thị tại Mái Ấm Khiếm Thị Nhật Hồng.
              </p>
              <div className="flex gap-4">
                <a href="#" className="w-10 h-10 rounded-full border border-white/30 flex items-center justify-center hover:bg-white/10 transition-colors cursor-pointer">
                  <i className="ri-facebook-fill text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 rounded-full border border-white/30 flex items-center justify-center hover:bg-white/10 transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-lg"></i>
                </a>
                <a href="mailto:xuanthaomtgtd@gmail.com" className="w-10 h-10 rounded-full border border-white/30 flex items-center justify-center hover:bg-white/10 transition-colors cursor-pointer">
                  <i className="ri-mail-line text-lg"></i>
                </a>
                <a href="tel:0785976111" className="w-10 h-10 rounded-full border border-white/30 flex items-center justify-center hover:bg-white/10 transition-colors cursor-pointer">
                  <i className="ri-phone-line text-lg"></i>
                </a>
              </div>
            </div>
            <div className="md:col-span-4">
              <div className="space-y-8">
                <div>
                  <h3 className="text-pink-100/60 text-xs uppercase tracking-wider mb-3 font-medium">ĐỊA CHỈ</h3>
                  <p className="text-white text-sm leading-relaxed">Mái Ấm Khiếm Thị Nhật Hồng<br />TP. Hồ Chí Minh, Việt Nam</p>
                </div>
                <div>
                  <h3 className="text-pink-100/60 text-xs uppercase tracking-wider mb-3 font-medium">ĐIỆN THOẠI / ZALO</h3>
                  <p className="text-white text-sm">0785976111 - 0976753302</p>
                </div>
                <div>
                  <h3 className="text-pink-100/60 text-xs uppercase tracking-wider mb-3 font-medium">EMAIL</h3>
                  <p className="text-white text-sm">xuanthaomtgtd@gmail.com</p>
                </div>
              </div>
            </div>
            <div className="md:col-span-3">
              <div className="w-full md:w-9/12 ml-auto">
                <img 
                  alt="Nghệ nhân khiếm thị đang làm việc" 
                  className="w-full h-80 object-cover object-center rounded-xl" 
                  src="https://drive.google.com/thumbnail?id=1ZDXXA1O8fEOn3H6lWiaekm2-WldZelAH&sz=w2000"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-white/20">
          <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <p className="text-pink-100/60 text-xs">© 2025 Hearts of Love. All rights reserved.</p>
              <div className="flex gap-6">
                <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-pink-100/60 text-xs hover:text-white transition-colors cursor-pointer">
                  Powered by Readdy
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
